import React, { useState, useEffect, useRef } from "react";
import { HeaderCRO } from "./HeaderCRO";
import { HeroCRO } from "./HeroCRO";
import { MentorSectionCRO } from "./MentorSectionCRO";
import { AlumniSection } from "./AlumniSection";
import { ProgrammeSection } from "./ProgrammeSection";
import { YoutubeSection } from "./YoutubeSection";
import { IndustrySection } from "./IndustrySection";
import { InstagramReelsSection } from "./InstagramReelsSection";
import { CTASection } from "./CTASection";
import { MapSection } from "./MapSection";
import { FAQSectionCRO } from "./FAQSectionCRO";
import { FooterCRO } from "./FooterCRO";
import { ApplicationModal } from "./ApplicationModal";
// import { StickyMobileCTA } from "./StickyMobileCTA";
import { trackPageView, trackScrollDepth } from "../utils/analytics";

export const LandingPageCRO = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSource, setModalSource] = useState("unknown");
  const [modalMode, setModalMode] = useState("application");
  const scrollTracked = useRef({ 25: false, 50: false, 75: false, 100: false });
  const pageStartTime = useRef(Date.now());

  // Track page view on mount
  useEffect(() => {
    trackPageView(
      window.location.pathname,
      "The Free Birds Collective - Landing Page"
    );
  }, []);

  // Track scroll depth
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollPercentage = Math.round(
        (scrollTop / (documentHeight - windowHeight)) * 100
      );

      [25, 50, 75, 100].forEach((threshold) => {
        if (
          scrollPercentage >= threshold &&
          !scrollTracked.current[threshold]
        ) {
          scrollTracked.current[threshold] = true;
          trackScrollDepth(threshold);
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const openModal = (source = "unknown", mode = "application") => {
    setModalSource(source);
    setModalMode(mode);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalSource("unknown");
    setModalMode("application");
  };

  return (
    <div className="min-h-screen">
      <HeaderCRO onEnrollClick={() => openModal("header", "application")} />
      <HeroCRO onEnrollClick={() => openModal("hero", "application")} />
      <MentorSectionCRO
        onEnrollClick={() => openModal("mentor_section", "application")}
      />
      <AlumniSection />
      <ProgrammeSection
        onApplyClick={(mode) =>
          openModal("programme_section", mode || "application")
        }
      />
      <YoutubeSection />
      <IndustrySection />
      <InstagramReelsSection />
      <CTASection
        onApplyClick={() => openModal("cta_section", "application")}
      />
      <MapSection />
      <FAQSectionCRO />
      <FooterCRO />
      {/* <StickyMobileCTA
        onEnrollClick={() => openModal("sticky_mobile_cta", "application")}
      /> */}
      <ApplicationModal
        isOpen={isModalOpen}
        onClose={closeModal}
        mode={modalMode}
        source={modalSource}
      />
    </div>
  );
};
